import { optionsToStrategy } from '@/common/utils/optionsToStrategy';

export const options = [
  { label: 'SH Informática', value: 'internal_sh_informatica' },
  { label: 'Contratante', value: 'client' },
];

export const strategy = optionsToStrategy(options);
